import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Card, Row, Col, FormText } from 'reactstrap';
import styles from 'components/styles.module.scss';
import STRINGS from 'helpers/strings';
import { BEHAVIOUR } from 'helpers/constants';
import { getLocalizedText } from 'helpers/language';

const NumberInputComponent = (props) => {
  const { data, isResponseWrong, index, errors, language } = props;
  const answer = data.answer;

  return (
    <Card
      className={
        isResponseWrong
          ? `${styles["highlight-div"]} ${styles["card-ui"]} m-3 p-3`
          : `${styles["card-ui"]} m-3 p-3`
      }
    >
      <Row>
        <Col md={11} className={`${styles["custom-col"]} ps-1`}>
          <span>
            <span>
              {data.behaviour === BEHAVIOUR.MANDATORY ? "*" : null}
            </span>
            {index + 1}.
          </span>
          <div
            className={
              data.behaviour === BEHAVIOUR.MANDATORY
                ? `${styles["questions-ui"]} pe-0 ps-2`
                : "ps-2"
            }
            dangerouslySetInnerHTML={{
              __html: getLocalizedText(language, data.question, data.sp_question),
            }}
          ></div>
        </Col>
      </Row>
      <div className="mt-2">
        <FormGroup>
          <Input
            type="number"
            step="any"
            id={`${index}`}
            name={`${index}`}
            onBlur={(val) => {
              data.setSelectedOption({
                ...(answer?.[0] || {}),
                value: val.target.value,
              });
            }}
            placeholder={STRINGS.ENTER_NUMBER}
          />
        </FormGroup>
        <div>
          <FormText className={styles["error-text"]} color="danger">
            {errors}
          </FormText>
        </div>
      </div>
    </Card>
  );
};

NumberInputComponent.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isResponseWrong: PropTypes.bool,
  errors: PropTypes.string,
  language: PropTypes.string,
};

export default NumberInputComponent;
